import { css, html, LitElement } from 'lit';

const NAME = 'afs-component';

class AfsComponent extends LitElement {
  className: '';

  static get properties() {
    return {
      className: { type: String }
    };
  }

  constructor() {
    super();
    this.className = '';
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  static styles = css`
    :host {
      margin: 0 auto;
      overflow: hidden;
      grid-column: 1 / -1;
  `;

  render() {
    return html`<div className="#${this.className}"></div>`;
  }
}

export function defineAfsComponent() {
  if (!customElements.get(NAME)) {
    customElements.define(NAME, AfsComponent);
  }
}
